import { useEffect } from 'react';

import { ClickTarget, click } from '@tracking';

import type { UseAnalyticsWrapperProps } from './interfaces';

const useAnalyticsWrapper = ({
  shouldTrackClick,
  trackEvent,
  containerRef,
}: UseAnalyticsWrapperProps) => {
  useEffect(() => {
    let eventTracker;
    const container = containerRef.current;

    if (shouldTrackClick && container) {
      eventTracker = (event) => {
        const target = event.target as HTMLElement;
        const anchorLink = target.closest('a');
        const button = target.closest('button');
        const text = target.innerText;
        if (anchorLink || button) {
          trackEvent(
            click({
              clickTarget: anchorLink ? ClickTarget.AnchorLink : ClickTarget.Button,
              clickText: text,
            })
          );
        }
      };
      container.addEventListener('click', eventTracker, { passive: true });
    }

    return () => {
      if (eventTracker && container) {
        container.removeEventListener('click', eventTracker, {
          passive: true,
        } as EventListenerOptions);
      }
    };
  }, [shouldTrackClick, trackEvent, containerRef]);
};

export default useAnalyticsWrapper;
